<template>
  <div class="link-page">
    <header-pane
      class="link-page__header"
      colorType="light"
      :pageTitle="$tc('LinkPage.pageTitle')"
      navigationCurrent="link"
      :hasHeaderNav="hasHeaderNav"
    />

    <link-pane />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import LinkPane from '@/components/LinkPage/LinkPane.vue'

/**
 * LINK ページ
 */
export default defineComponent({
  name: 'LinkPage',
  components: {
    HeaderPane,
    LinkPane,
  },
  props: {
    /**
     * ヘッダーナビ表示指定
     */
    hasHeaderNav: {
      type: Boolean,
      default: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.link-page {
  background: $gray1;
  min-height: var(--screen-height);
}
</style>

<style lang="scss">
.link-page .link-pane {
  height: calc(100vh - #{$headerPaneHeight});
}
</style>
